import { faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Rate } from "antd";
import React, { useRef, useState } from "react";
import { Col, Overlay, Row } from "react-bootstrap";
import Popover from "react-bootstrap/Popover";
import { labels } from "../../../localization/labels";
import SubmitButton from "../SubmitButton/SubmitButton";

const rateIcon = <FontAwesomeIcon icon={faStarHalfAlt} />;

const Rating = props => {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  return (
    <Row className="kmRow">
      <Col xs="12" md="4">
        <div className="ratingStars">
          <Rate disabled allowHalf value={props.averageRating}></Rate>
        </div>
        <div className="ratingFontSize">{props.averageRating}</div>
      </Col>
      <Col xs="6" md="4" className="ratings">
        <span>
          {labels.numberOfRatings}
          {props.votesCount ? props.votesCount : 0}
        </span>
      </Col>
      <Col xs="6" md="4" className="ratings">
        <SubmitButton
          buttonRef={target}
          className="rateBtnSize"
          variant="info"
          text={labels.rateNow}
          onClick={() => setShow(!show)}
          icon={rateIcon}
        />
      </Col>
      <Overlay
        target={target.current}
        show={show}
        placement="auto"
        rootClose
        onHide={() => setShow(false)}
      >
        <Popover id={`popover-rating`}>
          <Popover.Title as="h3">{labels.myRate}</Popover.Title>
          <Popover.Content>
            <Row>
              <Col>
                <Rate
                  value={Number(props.rating)}
                  onChange={rating => {
                    props.onRatingChange(rating);
                    setShow(false);
                  }}
                  allowClear={false}
                  show={props.show}
                ></Rate>
              </Col>
            </Row>
          </Popover.Content>
        </Popover>
      </Overlay>
    </Row>
  );
};

export default Rating;
